import theApi from './api'

// Note: VSCode currently doesn't respect object prop one-liner and removes
// import, so we need to rename the prop. This is already fixed in the repo and
// can be removed on next vscode releaase.
const theme = {
  api: theApi,
  example: 50,
  example1: 50,
  example2: 50,
  example3: 50,
  example4: 50,
  example5: 50,
}

export default theme



// WEBPACK FOOTER //
// ./src/components/styles/theme.js